<template>
  <v-card v-if="analysis" class="analysisDetails-header">
    <div class="d-flex flex-row no-gutters mt-2">
      <v-icon class="details-icons" :size="20">
        title
      </v-icon>
      <h1 class="analysisTitle">
        {{ analysis.documentDetails.title }}
      </h1>
    </div>
    <div class="d-flex flex-row align-start no-gutters mt-2">
      <v-icon class="details-icons" :size="20">
        description
      </v-icon>
      <p class="">
        {{ analysis.documentDetails.excerpt }}
      </p>
    </div>
  </v-card>
</template>
<script>

export default {
  name: 'DocumentSummary',
  props: {
    analysis: {
      type: Object,
      required: true,
    },
    analysisId: {
      type: String,
      required: true,
    },
    documentId: {
      type: String,
      required: true,
    },
  },
  methods: {
    selectAnalysis(analysis) {
      this.$emit('selectAnalysis', analysis);
    },
  },
};
</script>

<style scoped>
  .analysisTitle {
    font-size: 20px;
    font-weight: 400;
    color: #232137;
  }

  .analysisDescription {
    font-size: 16px;
    font-weight: 400;
    color: #232137;
  }

  .analysisDetails-header {
    background-color: #ffffff;
    margin-bottom: 4px;
  }

  .details-icons {
    padding-right: 8px;
  }
</style>
